import invite from './basic/invite.js';




/** WEBPACK FOOTER **
 ** ./src/scripts/app.js
 **/